import * as constants from './constants';

const initialState = {
    filters: {
        eventTypes: [],
        dateSelection: {
            from: null,
            to: null
        },
        eventName: '',
        gatewaySerialNumber: '',
        organizationId: null,   // ID from generalFilter orgs. sent in API payload
        organizationName: '',
        userEmail: ''
    },
    gatewayEventLogLoadingStatus: null,
    gatewayEventLogs: null,
    gatewayEventLogsError: null,
    nextCursor: null,
    hasMoreData: false,
    isLoadingMore: false,
    gatewayAttachment: {
        loadingStatus: null,
        fileId: null,
        downloadData: null,
        error: null
    },
    downloadLogsLimitCheck: {
        loadingStatus: null,
        data: null,
        error: null
    },
    downloadLogsZip: {
        loadingStatus: null,
        error: null
    }
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.FETCH_GATEWAY_EVENTS_LOG_SETTINGS: {
            const isAppending = action.isAppending || false;
            const existingEvents = state.gatewayEventLogs?.events || [];
            const newEvents = action.data?.events || [];

            return {
                ...state,
                gatewayEventLogs: {
                    ...action.data,
                    events: isAppending
                        ? [...existingEvents, ...newEvents]
                        : newEvents
                },
                // Only update main loading status on initial load, not on load more
                gatewayEventLogLoadingStatus: isAppending ? state.gatewayEventLogLoadingStatus : action.loadingStatus,
                nextCursor: action.data?.nextCursor || null,
                hasMoreData: !!action.data?.nextCursor,
                isLoadingMore: false,
                gatewayEventLogsError: action.error || null
            };
        }

        case constants.LOAD_MORE_GATEWAY_EVENTS:
            return {
                ...state,
                isLoadingMore: true
            };

        case constants.FETCH_GATEWAY_EVENTS_ATTACHMENT_SETTINGS:
            return {
                ...state,
                gatewayAttachment: {
                    loadingStatus: action.loadingStatus,
                    fileId: action.data?.fileId || null,
                    downloadData: action.data,
                    error: action.error || null
                }
            };

        case constants.CHECK_DOWNLOAD_LOGS_LIMIT_SETTINGS:
            return {
                ...state,
                downloadLogsLimitCheck: {
                    loadingStatus: action.loadingStatus,
                    data: action.data || null,
                    error: action.error || null
                }
            };

        case constants.DOWNLOAD_LOGS_ZIP_SETTINGS:
            return {
                ...state,
                downloadLogsZip: {
                    loadingStatus: action.loadingStatus,
                    error: action.error || null
                }
            };

        case constants.RESET_DOWNLOAD_LOGS_STATE:
            return {
                ...state,
                downloadLogsLimitCheck: initialState.downloadLogsLimitCheck,
                downloadLogsZip: initialState.downloadLogsZip
            };

        case constants.SET_GATEWAY_EVENT_LOG_FILTERS:
            return {
                ...state,
                filters: { ...state.filters, ...action.filters }
            };

        case constants.RESET_GATEWAY_EVENT_LOG_FILTERS:
            return {
                ...state,
                filters: {
                    ...initialState.filters,
                    // Preserve date selection when resetting other filters
                    dateSelection: state.filters.dateSelection
                },
                nextCursor: null,
                hasMoreData: false,
                isLoadingMore: false
            };

        case constants.CLEAR_STORE:
            return initialState;

        default:
            return state;
    }
}
